import React from 'react';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import { useSelector } from 'react-redux';
import TabbedPage from '../components/TabbedPage';
import PayslipRequestsApproval from '../components/PayrollComps/PayslipRequestsApproval';
import PayslipRequestScreen from '../components/PayrollComps/PayslipRequestScreen';
import { selectUserTypeId, USER_TYPE } from '../redux/slices/authSlice';

const TABS = [
    { key: 'approvals', label: 'Approvals', icon: FactCheckRoundedIcon, render: () => <PayslipRequestsApproval /> },
    { key: 'requests', label: 'My Requests', icon: ReceiptLongRoundedIcon, render: () => <PayslipRequestScreen /> },
];

export default function PayslipsPage() {
    const userTypeId = useSelector(selectUserTypeId);
    if (userTypeId === USER_TYPE.EMPLOYEE) return <PayslipRequestScreen />;
    if (userTypeId === USER_TYPE.MASTER_ADMIN) return <PayslipRequestsApproval />;
    return <TabbedPage tabs={TABS} />;
}
